import DataFactory from "../../model-factory/basic/data/DataFactory";
import {FactoryID} from "../../model-factory/type-interface/ModelFactoryType";
import DataModel from "../../model-factory/basic/data/DataModel";
import DataChoice, {IDataChoices} from "../../model-factory/basic/data/DataChoice";
import ApiRequestVO from "../../manager/api/ApiRequestVO";
import UserProfile from "../../manager/user/UserProfile";
import {IAnyObject} from "../../common/SimpleInterface";
import {IPopulateIDs} from "../../model-factory/type-interface/ModelFactoryInterface";
import ApiError from "../../manager/api/ApiError";


export type OrganisationUserType =
    "author" |
    "content_manager";

export class OrganisationUserDataChoice extends DataChoice
{
    userType: OrganisationUserType = "content_manager";
    profile:UserProfile = new UserProfile();

    constructor(object:IAnyObject)
    {
        const firstName:string = object.first_name ?? "";
        const lastName:string = object.last_name ?? "";
        const space = firstName && lastName ? " " : "";

        object.name = firstName + space + lastName;

        super(object);

        this.userType = !!object.is_author ? "author" : "content_manager"
        this.profile.userID = parseInt(this.id);
        this.profile.firstName = firstName;
        this.profile.lastName = lastName;
        this.profile.email = object.email ?? "";
    }
}

export interface IOrganisationUserDataChoices extends IDataChoices
{
    [key: string]: OrganisationUserDataChoice;
}

export class OrganisationUserDataModel extends DataModel
{
    organisationID:number = 0;
    choices: IOrganisationUserDataChoices = {};

    applyModelConditions()
    {
        this.organisationID = this.populateIDs.organisation_id ?? 0;
    }

    choiceList(choiceOrder?:string[]): OrganisationUserDataChoice[]
    {
        return super.choiceList(choiceOrder) as OrganisationUserDataChoice[];
    }


    getPopulateRequestVO(): ApiRequestVO|null
    {
        const requestVO = new ApiRequestVO(true);
        requestVO.endpoint = "/post/organisation/"+this.organisationID+"/users";
        return requestVO;
    }

    populateWithRequestResponse(response: IAnyObject, replaceData:boolean): ApiError | null
    {
        let error =  super.populateWithRequestResponse(response, replaceData);
        if(error){
            return error;
        }

        let entryObjects:IAnyObject[] = response.users && Array.isArray(response.users) ? response.users : [];

        this.populateChoiceList(entryObjects, replaceData);
        return null;
    }

    factory(): OrganisationUserDataFactory
    {
        return super.factory() as OrganisationUserDataFactory;
    }
}

export default class OrganisationUserDataFactory extends DataFactory
{

    id: FactoryID = "organisation_user_data";

    constructor()
    {
        super();
    }

    birth(id: string): OrganisationUserDataModel
    {
        return new OrganisationUserDataModel(id);
    }

    organisationUserDataModel(organisationID:number): OrganisationUserDataModel
    {
        const populateIDs:IPopulateIDs = {
            organisation_id: organisationID
        }
        return this.requireModel(populateIDs) as OrganisationUserDataModel
    }

    birthDataChoice(object:IAnyObject): OrganisationUserDataChoice
    {
        return new OrganisationUserDataChoice(object);
    }
}